import { Link } from 'react-router-dom'
import { cn } from '@/lib/utils'

export interface AccountTileProps {
  title: string
  to?: string
  onClick?: () => void
  className?: string
}

export function AccountTile({ title, to, onClick, className }: AccountTileProps) {
  const baseClass = cn(
    'group flex aspect-square flex-col items-start justify-end border border-ink/10 bg-paper p-5 text-left transition-all duration-300 hover:border-ink/30 hover:bg-wd-light-grey',
    className
  )

  const label = (
    <span className="text-xs font-semibold uppercase tracking-[0.14em] text-carbon transition-colors group-hover:text-wd-orange">
      {title}
    </span>
  )

  if (to) {
    return (
      <Link to={to} className={baseClass}>
        {label}
      </Link>
    )
  }

  return (
    <button type="button" onClick={onClick} className={baseClass}>
      {label}
    </button>
  )
}
